import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";
import { AxiosError } from "axios";

export type AttendanceLocalDepartmentCreateData = Pick<
    AttendanceLocalDepartment,
    | "ativo"
    | "misto"
> & {
    setor_id: number;
    unidade_slug: string;
}

export function useAttendanceLocalDepartmentCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocalDepartment,
        AxiosError<{ detail: string; }>,
        AttendanceLocalDepartmentCreateData
    >({
        mutationKey: ["attendance-local", "department", "create"],
        mutationFn: async (data) => {
            return apisiseci.post(
                `/cms/setor_unidade/`, data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
        },
        onSuccess: async () => {
            toast.success("Setor cadastrado com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["department-available", "list"],
                })
            ]);
        },
        onError: (error) => {
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
            console.log(error);
        },
    });

    return mutation;
}
